import * as Sentry from "@sentry/vue";
import SentryTransactionWrapper from "./sentry.js";

const __transaction__ = new SentryTransactionWrapper();

const getLocation = async () => {
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        var crd = pos.coords;

        resolve({
          latitude: crd.latitude,
          longitude: crd.longitude,
          accuracy: crd.accuracy
        });
      },
      (err) => {
        console.warn("Geolocation unavailable (" + err.code + "): " + err.message);

        reject();
      },
      options
    );
  });
};

const fetchLocationFromApi = async (coordinates) => {
  __transaction__?.start?.({
    op: "location",
    name: "Get Location 3rd party scan"
  });

  const location = {
    positioning: 0,
    latitude: 0,
    longitude: 0,
    country: "",
    source: ""
  };

  const { latitude, longitude } = coordinates || {};

  if (!(latitude && longitude)) {
    const ipLocationApiUrl = "https://free.freeipapi.com/api/json";

    const ipLocationSpan = __transaction__?.makeSpan?.({
      op: "location-ip",
      name: "IP-based geolocation fetch",
      data: {
        url: ipLocationApiUrl,
        method: "GET"
      }
    });

    try {
      const response = await fetch(ipLocationApiUrl);
      const data = await response.json();

      location.positioning = 2; // IP
      location.latitude = data.latitude;
      location.longitude = data.longitude;
      location.country = data.countryName;
      location.source = "IP";
    } catch (error) {
      Sentry?.captureException?.(error);
    } finally {
      ipLocationSpan?.end?.();
    }
  } else {
    location.positioning = 4; // GPS
    location.latitude = latitude;
    location.longitude = longitude;
    location.source = "GPS";

    const openStreetUrl = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`;

    const reverseGeocodingSpan = __transaction__?.makeSpan?.({
      op: "location-country",
      name: "Reverse geocoding fetch",
      data: {
        url: openStreetUrl,
        method: "GET"
      }
    });

    try {
      const response = await fetch(openStreetUrl);
      const data = await response.json();
      if (data.address && data.address.country) {
        location.country = data.address.country;
      }
    } catch (error) {
      Sentry?.captureException?.(error);
    } finally {
      reverseGeocodingSpan?.end?.();
    }
  }

  __transaction__?.end?.();
  return location;
};

export { getLocation, fetchLocationFromApi };
